import React, { useContext, useState } from 'react';
import HowInfo from '../HowInfo/HowInfo';
import ArccosEmail from '../ArccosEmail/ArccosEmail';
import PlayerInsightButton from '../../PlayerInsightButton/PlayerInsightButton';
import { LocalizationContext } from '../../../context/localizationContext';
import ExternalLink from '../../../assets/images/icons/external-link.svg';
import Styles from './GeneralInfo.module.scss';

const GeneralInfo = (props) => {
  const localization = useContext(LocalizationContext);
  const [showInstructions, setShowInsructions] = useState(false);
  const { tileText } = localization;
  const { setLoading, setTileComponent } = props;

  return (
    <div className={Styles.generalInfoContainer}>
      {showInstructions
        ? <HowInfo toggleInstructions={setShowInsructions} />
        : (
          <div className={Styles.generalInfo}>
            <div>{tileText.description.boldDescription}</div>
            <div>{tileText.description.regularDescription}</div>
            <a
              className={Styles.arccosSiteLink}
              href='https://www.arccosgolf.com/'
              target='__blank'>
              {tileText.description.arccosLearnLink}
              <img src={ExternalLink} alt='link' />
            </a>
            <PlayerInsightButton
              label={tileText.description.linkArccosBtnText}
              onClick={() => setTileComponent(<ArccosEmail setLoading={setLoading} />)}
            />
            <button
              className={Styles.howLink}
              type='button'
              onClick={() => setShowInsructions(true)}
            >
              {tileText.description.howLink}
            </button>
          </div>
        )
      }
    </div>
  );
};

export default GeneralInfo;
